// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, withRouter } from 'react-router-dom';

// hook
import useShouldChange from './hooks/useShouldChange';

function RedirectIndex({ path, ...rest }) {
  const { isChangeLocale, pathname } = useShouldChange();

  return (
    <Route
      path={path}
      {...rest}
      render={() =>
        !isChangeLocale ? (
          <></>
        ) : (
          <Redirect
            to={{
              pathname,
            }}
          />
        )
      }
    />
  );
}

RedirectIndex.propTypes = {
  path: PropTypes.string.isRequired,
};

export default withRouter(RedirectIndex);
